var map = {
	"./Arrow.gif": "57pk",
	"./Fred-logo.jpg": "8up6",
	"./JsecureColorTif.jpg": "2oNR",
	"./VbV_TC_2CRev_sm.jpg": "zM/j",
	"./app-bg.png": "2Otq",
	"./app_banner.png": "p2S8",
	"./bg.png": "C34Q",
	"./bracelets-spec-pc.jpg": "cEhj",
	"./bracelets-spec.jpg": "1AGz",
	"./cadrage_bg.jpg": "m5w8",
	"./cadrage_bg_1.jpg": "i7yk",
	"./cadrage_bg_2.png": "o+X/",
	"./cadrage_bg_2_1.png": "vE0l",
	"./cadrage_bg_3.jpg": "hy3W",
	"./cadrage_bg_4.jpg": "DNv8",
	"./cart-no.png": "VmlR",
	"./count-down-bg-big-size.jpg": "t2l3",
	"./count-down-bg.jpg": "0ih6",
	"./countdown-bg-en.png": "OjvC",
	"./countdown-bg-mb-en.png": "BA83",
	"./countdown-bg-mb.png": "tnJW",
	"./countdown-bg.png": "LuaY",
	"./default-avatar.png": "PsX4",
	"./dior-产品logo.png": "DJIu",
	"./fonts/Helvetica.eot": "C9iC",
	"./fonts/Helvetica.ttf": "Fp9y",
	"./fonts/Helvetica.woff2": "RujK",
	"./fred_logo.png": "ZpdA",
	"./home-bg-mb.jpg": "JaG3",
	"./home-bg.jpg": "3b/Y",
	"./icon/add+.png": "B7CY",
	"./icon/add_no.png": "JrV/",
	"./icon/address.png": "rI9u",
	"./icon/cart.png": "1VRk",
	"./icon/delete.png": "ty0o",
	"./icon/eye.png": "l2uD",
	"./icon/left.png": "8AFt",
	"./icon/logo-2.png": "Ki7x",
	"./icon/logo-3.png": "hgqE",
	"./icon/logo-4.png": "L2gR",
	"./icon/mine.png": "GSkE",
	"./icon/nav-cart.png": "XjQC",
	"./icon/password.png": "IH9h",
	"./icon/search.png": "GY9m",
	"./icon/sell-out.png": "SVhp",
	"./icon/sellout.png": "113C",
	"./icon/tagheuer_logo.png": "wuJ6",
	"./icon/user.png": "TlOy",
	"./icon/品牌归属.png": "WGBX",
	"./icon/售罄.png": "DiPl",
	"./icon/售罄_优惠券标签.png": "sGzY",
	"./icon/微信支付.png": "sB+o",
	"./icon/成功.png": "vu2G",
	"./icon/箭头.png": "ab/w",
	"./index-bg-mobile@2x.jpg": "Gr0E",
	"./index-bg.jpg": "bMg+",
	"./left.png": "xDWF",
	"./logo-fendi.png": "z3xB",
	"./logo-mb.png": "PreA",
	"./logo.png": "7Otq",
	"./mobile/_订单.png": "LA4e",
	"./mobile/address.png": "JTUL",
	"./mobile/cart-cart.png": "Hss1",
	"./mobile/cart-mb-select.png": "YJsm",
	"./mobile/cart-mb.png": "w6j7",
	"./mobile/cart.png": "RZwC",
	"./mobile/cat-select.png": "XWY3",
	"./mobile/cat.png": "NmuN",
	"./mobile/cata.png": "xLV+",
	"./mobile/home-mb-select.png": "g7m3",
	"./mobile/home.png": "mQdu",
	"./mobile/left.png": "EnDv",
	"./mobile/menu.png": "2oj2",
	"./mobile/my-mb-select.png": "k+7V",
	"./mobile/my.png": "i9oP",
	"./mobile/outline-tag.png": "swUe",
	"./mobile/pagehome.png": "gwDK",
	"./mobile/password.png": "3Afq",
	"./mobile/profile.png": "zhT1",
	"./mobile/sallout.png": "3U2m",
	"./mobile/user.png": "fdLE",
	"./mobile/userlogin.png": "2emS",
	"./mobile/付款.png": "8A5f",
	"./mobile/快递 (1).png": "ejC9",
	"./order.png": "x5oV",
	"./pc-bg.png": "5RU8",
	"./pc_banner.png": "MTEA",
	"./popcart.png": "2aqk",
	"./profile.png": "65UA",
	"./sc_learn_68x37.gif": "Oxxq",
	"./search-no.png": "hW8B",
	"./soldout.png": "kPyC",
	"./spec-selected.png": "4FWg",
	"./spec1-pc.jpeg": "xDsm",
	"./spec1.jpeg": "JWx2",
	"./spec1.jpg": "YCxa",
	"./t_h.png": "OnhG",
	"./t_h_menu.png": "lcdh",
	"./tagheuer_logo.png": "l34f",
	"./tagheuer_logo_1.png": "ClOq",
	"./tagheuer_logo_menu.png": "yTJF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1